var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 663,
    height: 576,
    viewBox: "0 0 663 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H662L617.811 74.6978H132.648L141.854 89.4373L356.357 91.2797L315.85 164.056L184.202 165.899L250.486 280.13L209.059 354.749L1 1Z",
    stroke: "#CBB488",
    strokeOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M464.989 91.2797L377.531 89.4373L297.87 241.103L221.333 376.814L263.375 445.029L340.706 316.058H397.784L295.596 500.302L338.865 574L477.877 326.191C493.344 299.66 484.322 280.744 477.877 274.603C508.074 270.181 530.352 235.297 537.717 218.408L609.525 89.4373L523.908 91.2797L443.815 235.912H383.975L464.989 91.2797Z",
    stroke: "#CBB488",
    strokeOpacity: 0.15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTest);
export default __webpack_public_path__ + "static/media/logo-test.73406a8d5c79261c997222163ae9a984.svg";
export { ForwardRef as ReactComponent };